import type { OrderServiceGetManyRequest } from '@/models/orders';
import * as CancellationUtils from '@/utils/cancellation.utils';
import { handleError } from '@/utils/error.util';
import { defineStore } from 'pinia';
import type { ModelOrderResponse } from '@layup/api-sdk';

export const useCancellationStore = defineStore('cancellations', {
  state: () => ({
    unresolvedCancellations: null as ModelOrderResponse[] | null,
    loading: false,
    isError: false,
  }),
  actions: {
    async fetchUnresolvedCancellations(params?: OrderServiceGetManyRequest) {
      this.loading = true;
      this.isError = false;
      try {
        this.unresolvedCancellations = await CancellationUtils.fetchUnresolvedCancellations(params);
      } catch (error: any) {
        handleError(error);
        this.isError = true;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.$reset();
    },
  },
  persist: true,
});
